import React, { createContext, useReducer, useContext } from "react";

// Initial State
const initialState = {
    token: null,
    refreshToken: null,
    user: null,
};

// Reducer Function
const authReducer = (state, action) => {
    switch (action.type) {
        case "LOGIN":
            return { ...state, token: action.payload.token, refreshToken: action.payload.refreshToken, user: action.payload.user };
        case "LOGOUT":
            return { ...initialState };
        default:
            return state;
    }
};

// Create Context
const AuthContext = createContext(null); 

// Provider Component
export const AuthProvider = ({ children }) => {
    const [state, dispatch] = useReducer(authReducer, initialState);

    const logout = () => {
        dispatch({ type: "LOGOUT" });
    };

    return (
        <AuthContext.Provider value={{ state, dispatch, logout }}>
            {children}
        </AuthContext.Provider>
    );
};

// Custom Hook for Using Auth Context
export const useAuth = () => {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error("useAuth must be used within an AuthProvider");
    }
    return context;
};
